import { useEffect } from 'react';

const upsertMetaByName = (name, content) => {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const upsertMetaByProperty = (property, content) => {
  if (!content) return;
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const upsertLink = (rel, href) => {
  if (!href) return;
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

const upsertJsonLd = (id, data) => {
  try {
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement('script');
      el.type = 'application/ld+json';
      el.id = id;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
  } catch {}
};

const Meta = ({ title, description, children }) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) upsertMetaByName('description', description);

    const AUTHOR_NAME = 'Mert Batut';
    const AUTHOR_URL = 'https://www.mertbatut.com.tr';
    upsertMetaByName('author', AUTHOR_NAME);
    upsertMetaByName('creator', AUTHOR_NAME);
    upsertMetaByProperty('article:author', AUTHOR_URL);
    upsertLink('author', AUTHOR_URL);

    upsertJsonLd('ld-author', {
      '@context': 'https://schema.org',
      '@type': 'Person',
      name: AUTHOR_NAME,
      url: AUTHOR_URL
    });
  }, [title, description]);

  return children || null;
};

export default Meta;
